import classNames from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import Button from '../../components/Button';
import { StepsUpdateContext } from '../../components/Steps/StepsContext';
import { TicketRoutePaths } from '../../interfaces/Routes';
import { sendRescheduleClicked } from '../../services/Analytics';
import StepsService from '../../services/StepsService';
import styles from './ConfirmReschedule.module.scss';

interface ConfirmRescheduleProps {
  availabilityProvided?: boolean;
  cancelingEnabled: boolean;
  hashId: string;
  reschedulingEnabled: boolean;
}

const ConfirmReschedule: FC<ConfirmRescheduleProps> = ({
  hashId, cancelingEnabled, reschedulingEnabled, availabilityProvided,
}) => {
  const { navigateToPrevStep } = React.useContext(StepsUpdateContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onReschedule = () => {
    sendRescheduleClicked();
    navigateToPrevStep();
  };

  const onCancel = () => {
    navigate(StepsService.getStepUri(hashId, TicketRoutePaths.cancel));
  };

  const changeButtonClass = classNames(styles.changeAppointmentButtonsContainer, {
    [styles.alignRight]: !reschedulingEnabled && cancelingEnabled,
  });

  return (
    <section className={styles.rescheduleContianer}>
      <h3 className={styles.rescheduleTitle}>{t('confirmSection:changeAppointment')}</h3>
      <p className={styles.rescheduleDescription}>{t('confirmSection:changeAppointmentDescription')}</p>
      <div className={changeButtonClass}>
        {reschedulingEnabled && (
          <Button
            ariaLabel={t('confirmSection:change')}
            onClick={onReschedule}
            size="small"
            text={availabilityProvided ? t('confirmSection:changeAvailability') : t('confirmSection:change')}
            variant="outline"
          />
        )}
        {cancelingEnabled && (
          <Button
            ariaLabel={t('confirmSection:cancel')}
            className={styles.cancelAppointmentButton}
            onClick={onCancel}
            size="small"
            text={t('confirmSection:cancel')}
            variant="text"
          />
        )}
      </div>
    </section>
  );
};

export default ConfirmReschedule;
